import React from "react";
import { Button, FormControl, Modal, ControlLabel, Alert } from "react-bootstrap";
import immutable from "immutable";
import context from "./../../lib/context.js";
import ajax from "./../../lib/ajax.js";
import moment from "moment";
import SpecialBillForm from "./specialbill-form.jsx";
import FreetimePicker from "./free-timepicker.jsx";

export default class SendSubmitTimecardReminder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            request: {
                
            }
        };

        this.onSend = this.onSend.bind(this);
    }

    componentDidAmount() {
        this.state({
            show: false
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.show != nextProps.show) {
            this.setState({
                show: nextProps.show,
            });
        }
    }

    onSend(inputs) {
        const self = this;
        
        context.message({
            show: true,
            type: "loading",
            message: "Sending. Please wait..."
        });

        var request = {
            timecardId: this.props.timecardId,
            additionalNotes: inputs.additionalNotes.value,
            role: this.props.role
        }

        ajax.api()
            .post("send-submit-timecard-reminder", request)
            .then(function (res) {
                self.props.afterSend(self.props.timecardId);
                self.props.toggleDialog(false, 0)

                context.message({
                    show: false,
                });
            })
            .catch(function (err) {
                let data = err.response === undefined ? err : err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    render() {
        const self = this;
        const vm = self.props.vm;
        const inputs = {};
        
        if (vm != null) {
            var peopleName = '';
            var timecardId = '';
            
            if (this.props.peopleName !== undefined) {
                peopleName = this.props.peopleName.split(',')[1] + ' ' + this.props.peopleName.split(',')[0];
            }

            if (this.props.timecardId !== undefined) {
                timecardId = this.props.timecardId;
            }
            
            var url = vm.timecardUrl.replace('?tid=0', '?tid=' + timecardId);
            var reminder = vm.submitTimecardReminderBody.replace('$ASSOCIATE_NAME$', peopleName).replace(/\$VBCRLF\$/gi, '<br />').replace('$WEBSITE$', '<a href="' + url + '">' + url + '</a>').split('$SUPERVISOR_NOTES$');

            return (
                <Modal show={this.state.show}>
                    <Modal.Header >
                        <Modal.Title><i className="fa fa-envelope-o"></i> Send Reminder</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <ControlLabel>Message Preview:</ControlLabel>
                                    <div className="ap-send-submit-reminder-message">
                                        <div dangerouslySetInnerHTML={ { __html: reminder[0] } }>

                                        </div>
                                        <FormControl componentClass="textarea" rows="3"
                                            inputRef={node => inputs.additionalNotes = node}
                                            onChange={(evt) =>  { 
                                                inputs.additionalNotes.value = evt.target.value
                                            }}
                                            placeholder="- Enter additional notes here -" />
                                        <div dangerouslySetInnerHTML={ { __html: reminder[1] } }>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
    
                    <Modal.Footer>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-4 ap-top-margined">
                                    <Button className="btn-info ap-fullsize" onClick={(evt) => this.onSend(inputs)}>Send</Button>
                                </div>
                                <div className="col-md-4 ap-top-margined"></div>
                                <div className="col-md-4 ap-top-margined">
                                    <Button className="btn-info ap-fullsize" onClick={() => this.props.toggleDialog(false, 0)}>Cancel</Button>
                                </div>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            );
        }
        else {
            return (<div></div>);
        }
    }
}